import Image from 'next/legacy/image';

import { BigNumber } from '@common/BigNumber';

import RealPeopleImage from '@public/img/success-stories/real-people.png';

export const RealPeopleBanner = (): JSX.Element => (
  <div className="relative hidden items-center justify-center overflow-hidden py-10 lg:flex">
    <Image layout="fill" objectFit="cover" src={RealPeopleImage} />
    <div className="z-10 whitespace-nowrap text-mono-white">
      <BigNumber>Real people</BigNumber>
    </div>
  </div>
);
